import { Loading } from "@wfp/ui"
import ExcelUploader from "components/Shared/ExcelUploader/ExcelUploader"

import { useEffect } from "react"
import { useParams } from "react-router-dom"
import { useGetGorpReportByIdQuery, usePostGorpReportMutation } from "services/gorp"
import { formatDate } from "utils/helpers"
import ViewReport from "./ViewReports"

export default function UploadReportExcel() {
  const { reportId } = useParams()

  const [postReport, { error, isLoading, isSuccess, data: reportData }] = usePostGorpReportMutation()
  const { data } = useGetGorpReportByIdQuery(reportId ? +reportId : 0, { skip: !reportId })

  const handleSelect = (file?: File) => {
    if (!file || !data || !reportId) return

    const formData = new FormData()
    formData.append("files", file)

    postReport({ file: formData, rid: +reportId })
  }

  useEffect(() => {
    if (error) {
      alert((error as any).data)
    }
  }, [error])

  return (
    <>
      <div className="flex justify-between">
        <div className="flex gap-x-4">
          <p>
            <strong>{data?.countryName}</strong>
          </p>
          <p>|</p>
          <p>Report N. {data?.reportId}</p>
          <p>| Created on {formatDate(data?.reportCreateDate || "")}</p>
        </div>
        <p>{data?.reportStatusName}</p>
      </div>

      {!isLoading && !isSuccess && <ExcelUploader onSelect={handleSelect} />}

      {isSuccess && <ViewReport reportData={reportData} />}

      {isLoading && <Loading />}
    </>
  )
}
